export default class ProjectsSelection {
    playing = true
    isMuted = true // Force muted on load to comply with browser autoplay rules

    constructor({ el, container }) {
        this.el = el
        this.tabs = this.el.querySelectorAll(".tab-content")
        this.tabNavs = container.querySelectorAll(".tab-nav .tab-link")

        let startIndex = 0

        const paramsString = window.location.search;
        const searchParams = new URLSearchParams(paramsString);

        const categories = [ 'advertising', 'cinema', 'experience-design']
      
        const categoryParam = searchParams.get('category_name');
        const pathSegment = window.location.pathname.split('/').filter(Boolean)[0];

        const activeValue = categories.includes(categoryParam) ? categoryParam : pathSegment;
        const foundIndex = categories.indexOf(activeValue);

        if (foundIndex > -1) {
            startIndex = foundIndex;
        }

        this.controls = this.el.querySelector(".toggle-play-pause")
        this.muteControls = this.el.querySelector(".toggle-sound")

        // Force UI to show "muted" state on init
        if (this.muteControls) {
            this.muteControls.classList.add('muted')
        }

        // Initialize active index and auto-play the first video (muted)
        this.index = startIndex
        this.showTab(this.index)

        this.tabs.forEach((tab, tabIndex) => {
            const $thumbs = tab.querySelectorAll(".post-thumb")
            const $videos = tab.querySelectorAll("video")

            $thumbs.forEach((thumb, i) => {
                thumb.addEventListener("click", () => {
                    this.clickThumb(i)
                })

                // Drag/Scrub functionality
                let isDragging = false;

                thumb.addEventListener("mousedown", (e) => {
                    isDragging = true;
                    this.scrubVideo(e, thumb, i);
                    if ($videos[i]) $videos[i].pause();
                });

                window.addEventListener("mousemove", (e) => {
                    if (isDragging) {
                        this.scrubVideo(e, thumb, i);
                    }
                });

                window.addEventListener("mouseup", () => {
                    if (isDragging) {
                        isDragging = false;
                        if ($videos[i] && this.playing) {
                            $videos[i].play();
                        }
                    }
                });
            })

            $videos.forEach((video, i) => {
                video.addEventListener('timeupdate', () => {
                    const percentage = (video.currentTime / video.duration) * 100;
                    if ($thumbs[i]) $thumbs[i].style.setProperty('--progress', percentage)
                });

                video.addEventListener('ended', () => {
                    const nextIndex = (i + 1) % $thumbs.length
                    this.clickThumb(nextIndex)
                });
            })
        })

        this.controls.addEventListener("click", () => {
            this.playing = this.controls.classList.contains("paused")

            if (this.playing) {
                this.playActiveVideo()
            } else {
                this.pauseAllVideos()
            }
            this.controls.classList.toggle('paused')
        })

        // Mute/Unmute Controls
        this.muteControls.addEventListener("click", () => {
            // Toggle global sound preference state
            this.isMuted = !this.muteControls.classList.contains("muted")
            
            // Sync audio mix instantly based on current tab/video layout
            this.syncVideoMuteStates()

            this.muteControls.classList.toggle('muted')
        })
    }

    scrubVideo(e, thumb, index) {
        const rect = thumb.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const width = rect.width;
        
        let percentage = Math.min(Math.max(x / width, 0), 1);
        
        const currentTab = this.tabs[this.index];
        const video = currentTab.querySelectorAll("video")[index];
        
        if (video && video.duration) {
            video.currentTime = video.duration * percentage;
            thumb.style.setProperty('--progress', percentage * 100);
            if (!thumb.classList.contains('active')) {
                this.clickThumb(index);
            }
        }
    }

    activateThumb(i) {
        const $thumbs = this.tabs[this.index].querySelectorAll(".post-thumb")
        $thumbs.forEach(thumb => thumb.classList.remove("active"))
        if ($thumbs[i]) $thumbs[i].classList.add("active")
    }

    pauseAllVideos() {
        const allVideos = this.el.querySelectorAll("video")
        allVideos.forEach(video => video.pause())
    }

    /**
     * Mutes every single video element on the page.
     * Unmutes ONLY the precise active video element IF this.isMuted is false.
     */
    syncVideoMuteStates() {
        const allVideos = this.el.querySelectorAll("video")
        
        // Always force total silence across everything by default
        allVideos.forEach(video => {
            video.muted = true
        })

        // Unmute ONLY the active video context if the user explicitly unmuted the player
        if (!this.isMuted) {
            const currentTab = this.tabs[this.index]
            if (currentTab) {
                const activeThumbIndex = Array.from(currentTab.querySelectorAll(".post-thumb")).findIndex(t => t.classList.contains('active'))
                const targetIndex = activeThumbIndex >= 0 ? activeThumbIndex : 0
                const activeVideo = currentTab.querySelectorAll("video")[targetIndex]
                
                if (activeVideo) {
                    activeVideo.muted = false
                    activeVideo.volume = 1.0
                }
            }
        }
    }

    playActiveVideo() {
        this.pauseAllVideos() 

        const currentTab = this.tabs[this.index]
        const activeThumbIndex = Array.from(currentTab.querySelectorAll(".post-thumb")).findIndex(t => t.classList.contains('active'))
        const targetIndex = activeThumbIndex >= 0 ? activeThumbIndex : 0

        const activeVideo = currentTab.querySelectorAll("video")[targetIndex]
        
        this.syncVideoMuteStates() 

        if (activeVideo && this.playing) {
            activeVideo.play().catch(err => console.log("Autoplay context handled:", err))
        }
    }

    clickThumb(i) {
        this.activateThumb(i)
        const currentTab = this.tabs[this.index]
        const posts = currentTab.querySelectorAll(".post-item")
        const videos = currentTab.querySelectorAll("video")

        posts.forEach((post, index) => {
            gsap.set(post, { autoAlpha: 0 })
            if (videos[index] && index !== i) {
                videos[index].pause()
                videos[index].currentTime = 0
            }
        })

        gsap.set(posts[i], { autoAlpha: 1 })
        
        this.syncVideoMuteStates()

        if (this.playing && videos[i]) {
            videos[i].play().catch(err => console.log(err))
        }
    }

    showTab(index) {
        this.index = index
        
        gsap.set(this.tabs, { autoAlpha: 0 })
        this.pauseAllVideos()

        const currentTab = this.tabs[index]
        gsap.set(currentTab, { autoAlpha: 1 })
        
        this.tabNavs.forEach(nav => nav.classList.remove("active"))
        if (this.tabNavs[index]) this.tabNavs[index].classList.add("active")

        const posts = currentTab.querySelectorAll(".post-item")
        posts.forEach(post => gsap.set(post, { autoAlpha: 0 }))
        if (posts[0]) gsap.set(posts[0], { autoAlpha: 1 })

        this.activateThumb(0)

        if (this.playing) {
            this.playActiveVideo()
        } else {
            this.syncVideoMuteStates()
        }
    }

    handleResize() {}
    dispose() {}
}